import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import Oruga from "@oruga-ui/oruga-next";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import "@oruga-ui/oruga-next/dist/oruga-full-vars.css";
import "@/assets/customOruga.css";
import "@/assets/appkit4/font.css";
import "@/assets/appkit4/font-icon/css/appkit-font.scss";
import "@/assets/popcorn-fonts.css";
import "@/assets/widgets.scss";
import { createPinia } from "pinia";
import { useAuthenticationStore } from "./stores/authentication";
import { throttle } from "./modules/utilities";
import axios from "axios";
import { RouterPath } from "./models/enum/routerPath";
import vueDOMPurifyHTML from "vue-dompurify-html";

const pinia = createPinia();
const authenticationStore = useAuthenticationStore(pinia);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      window.location.href = RouterPath.LoggedOut;
    }
    return Promise.reject(error);
  }
);

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

//Use promise here as - "Top-level await is not available in the configured target environment"
authenticationStore.getAuthenticationStatus().finally(() => {
  const app = createApp(App);
  app.use(pinia);
  app.use(router);
  app.use(vuetify);
  app.use(Oruga, {
    steps: {
      itemHeaderActiveClass: "steps-nav-item-active",
      itemHeaderPreviousClass: "steps-nav-item-previous",
      stepMarkerClass: "step-marker",
      stepDividerClass: "step-divider",
    },
    button: {
      rootClass: "button-root-color",
    },
    table: {
      tdDetailedChevronClass: "icon-root-color",
    },
    checkbox: {
      checkClass: "checkbox-color",
      checkCheckedClass: "checkmark-color",
    },
  });
  app.use(vueDOMPurifyHTML, {
    namedConfigurations: {
      email: {
        ALLOWED_TAGS: ["br", "strong", "em", "ul", "li", "b"],
      },
    },
  });
  authenticationStore.setContext();
  app.mount("#app");
  app.config.errorHandler = (err) => {
    //    console.log("TODO - post error to backend api for logging", err);
    console.error("Unexpected error occurred", err);
  };
});

const keepAlive = throttle(() => {
  authenticationStore.getAuthenticationStatus();
}, 3000);

window.addEventListener("scroll", keepAlive);
window.addEventListener("keyup", keepAlive);
